import { render } from "./SalesIndex.vue?vue&type=template&id=6db92552"
import script from "./SalesIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Sales/SalesIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6db92552"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6db92552', __exports__)) {
    api.reload('6db92552', __exports__)
  }
  
  module.hot.accept("./SalesIndex.vue?vue&type=template&id=6db92552", () => {
    api.rerender('6db92552', render)
  })

}


export default __exports__